import type { DsTableSort } from '@gde-mit/angular-design-system';

export type DocumentLibraryListSortApi = {
  sortBy: string;
  sortDir: 'asc' | 'desc';
};

const COLUMN_KEY_TO_SORT_BY: Record<string, string> = {
  ownerName: 'ownerName',
  fileName: 'fileName',
  fileType: 'fileType',
  sizeLabel: 'fileSizeBytes',
  status: 'status',
  uploadedAtLabel: 'createdAt',
  visibility: 'visibility',
};

/**
 * Maps table column sort state to document list API query params.
 *
 * @returns The result of this operation.
 * @param sort The sort value.
 */
export function documentLibrarySortToApi(sort: readonly DsTableSort[]): DocumentLibraryListSortApi {
  const active = sort[0];
  if (!active) {
    return { sortBy: 'createdAt', sortDir: 'desc' };
  }

  const sortBy = COLUMN_KEY_TO_SORT_BY[active.key];
  if (!sortBy) {
    return { sortBy: 'createdAt', sortDir: 'desc' };
  }

  return { sortBy, sortDir: active.direction };
}
